import {
  Text,
  View,
  Image,
  Stop,
  Rect,
  Svg,
  Defs,
  Font,
  StyleSheet,
  LinearGradient,
} from "@react-pdf/renderer";

const VerticalProduct = (props) => {
  const {
    element,
    bgColor,
    bgColorTwo,
    fontColor,
    previewColor,
    userLogo,
    withoutlogo,
    withoutlogoBasd64,
  } = props;

  Font.register({
    family: "UniversoBold",
    src: "../assets/fonts/UniversoBold.ttf",
  });
  Font.register({
    family: "NexaLight",
    src: "/../assets/fonts/NexaLight.otf",
  });
  Font.register({
    family: "NexaBold",
    src: "/../assets/fonts/NexaBold.otf",
  });

  const styles = StyleSheet.create({
    logo: {
      width: 100,
    },
    colletionBox: {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-end",
    },
    headerBox: {
      paddingBottom: 10,
      width: "100%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-end",
    },
    bottomlogoBox: {
      top: 40,
      width: "100%",
      display: "flex",
      alignItems: "flex-end",
    },
    productName: {
      fontFamily: "UniversoBold",
      display: "flex",
      textAlign: "right",
      fontSize: "22pt",
      marginBottom: 10,
      color: fontColor,
    },
    previewproductName: {
      fontFamily: "UniversoBold",
      display: "flex",
      textAlign: "right",
      alignItems: "flex-end",
      color: fontColor,
    },
    lineBox: {
      display: "flex",
      alignItems: "flex-end",
      marginBottom: 15,
      marginTop: 15,
    },
    line: {
      width: "30px",
      height: 1,
      backgroundColor: fontColor,
    },
    headeline: {
      display: "flex",
      width: "100%",
      height: 1,
      backgroundColor: fontColor,
    },

    finish: {
      fontFamily: "NexaBold",
      display: "flex",
      alignItems: "flex-end",
      marginBottom: 10,
    },
    sizeBox: {
      display: "flex",
      alignItems: "flex-end",
      marginBottom: 10,
    },
    previewsizeBox: {
      display: "flex",
      alignItems: "flex-end",
      alignItems: "center",
      gap: 10,
    },
    detailBox: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-end",
    },
    productBox: {
      padding: 0,
      display: "flex",
      flexDirection: "row",
    },
    firstBox: {
      width: "50%",
      display: "flex",
      flexDirection: "column",
      marginTop: 20,
      gap: 5,
    },
    secondBox: {
      width: "50%",
      display: "flex",
      flexDirection: "column",
      marginTop: 20,
      justifyContent: "space-around",
    },
    imageBox: {
      width: "100%",
    },
    productimage: {
      width: 180,
    },
    image: {
      width: "100%",
      height: "70%",
    },
    imageFaceBox: {
      display: "flex",
      flexDirection: "row",
      gap: 5,
      marginBottom: 5,
    },
    faceImage: {
      width: 82.5,
      height: 165,
    },
    textBold: {
      fontFamily: "NexaBold",
      // letterSpacing: "1px",
      // fontSize: "24px",
      color: fontColor,
    },
    textLight: {
      fontFamily: "NexaLight",
      // letterSpacing: "1px",
      color: fontColor,
    },

    previewname: {
      display: "flex",
      fontFamily: "NexaBold",
      flexDirection: "row",
      position: "absolute",
      fontSize: 10,
      bottom: 60,
      left: 40,
      color: previewColor,
    },
    previewsize: {
      fontFamily: "NexaLight",
      fontSize: 12,
      color: previewColor,
    },
    previewBoxDetail: {
      display: "flex",
      flexDirection: "row",
      width: "100%",
      position: "absolute",
      bottom: 40,
      left: 40,
    },
    previewSizeBox: {
      display: "flex",
      alignItems: "center",
      flexDirection: "row",
    },
    leftBox: {
      width: 185,
      height: 366,
      display: "flex",
      alignItems: "flex-start",
    },
    rightBox: {
      width: 310,
      height: 366,
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end",
      justifyContent: "space-between",
    },
    previewDetail: {
      width: "100%",
      height: 366,
      display: "flex",
      flexDirection: "row",
      gap: 0,
    },
    previeWImageDetail: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      marginBottom: 16,
      position: "relative",
    },
    imageBottomFaceBox: {
      display: "flex",
      flexDirection: "row",
      gap: 5,
    },
    imageface: {
      width: 70,
      height: 140,
    },
    previewImage: {
      padding: 1,
      border: "1px solid white",
      height: 360,
    },
    previewTextBold: {
      fontFamily: "NexaBold",
      // letterSpacing: "1px",
      // fontSize: '13px',
      color: fontColor,
    },
    previewTextLight: {
      fontFamily: "NexaLight",
      // letterSpacing: "1px",
      // fontSize: 8,
      color: fontColor,
    },
    previewTextFinish: {
      fontFamily: "NexaBold",
      alignItems: "flex-end",
      display: "flex",
      textAlign: "center",
    },
    productsize: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-end",
      alignItems: "center",
    },
  });

  return (
    <View>
      {(!element.product.preview || element.is_hide_preview) ? (
        <View style={{ position: "relative" }}>
          <Svg viewBox="0 0 595 842" width="100%" height="841.8">
            <Defs>
              <LinearGradient
                id="myLinearGradient"
                x1="1"
                y1="1.5"
                x2="0"
                y2="0"
              >
                <Stop offset="0%" stopColor={bgColorTwo} />
                <Stop offset="100%" stopColor={bgColor} />
              </LinearGradient>
            </Defs>
            <Rect
              fill="url('#myLinearGradient')"
              x="0"
              y="0"
              width="100%"
              height="842"
            />
          </Svg>
          <View style={{ position: "absolute", width: "100%", padding: 50 }}>
            <View style={styles.headerBox}>
              {(withoutlogo && withoutlogoBasd64) ? (
                <Image
                  cache={false}
                  style={{ width: 150 }}
                  src={withoutlogoBasd64}
                />
              ):null}
              {!withoutlogo ? (
                <Image
                  cache={false}
                  style={{ maxWidth: 150, maxHeight: 50 }}
                  src={
                    userLogo == "LOGO"
                      ? element.user_logo
                      : element.user_dark_logo
                  }
                />
              ):null}
            </View>
            <View>
              <View style={styles.headeline} />
            </View>
            <View style={styles.productBox}>
              <View style={{ ...styles.firstBox, height: 495 }}>
                <View style={styles.imageBox}>
                  <Image
                    src={element.image}
                    cache={false}
                    style={{ height: 495, width: 247.5 }}
                  />
                </View>
              </View>
              <View style={{ ...styles.secondBox, height: 495 }}>
                <View>
                  <Text style={{ ...styles.productName, paddingLeft: 10 }}>
                    {element.product.name}
                  </Text>
                  <View
                    style={{
                      ...styles.lineBox,
                      marginTop: 18,
                      marginBottom: 18,
                    }}
                  >
                    <View style={styles.line} />
                  </View>
                  <View style={{ ...styles.finish, marginTop: 10 }}>
                    <Text style={{ ...styles.textLight, fontSize: "15pt" }}>
                      Surface
                    </Text>
                    <Text
                      style={{
                        ...styles.textBold,
                        fontSize: "19pt",
                        marginTop: 2,
                      }}
                    >
                      {element.series || "Glosy"}
                    </Text>
                  </View>
                  <View
                    style={{
                      ...styles.lineBox,
                      marginTop: 18,
                      marginBottom: 18,
                    }}
                  >
                    <View style={styles.line} />
                  </View>
                  <View style={styles.sizeBox}>
                    {element.sizes.length > 0 ?
                      element.sizes.map((size, key) => {
                        return (
                          <View style={{ marginTop: 10 }} key={key}>
                            <View style={styles.productsize}>
                              <Text
                                style={{ ...styles.textBold, fontSize: "16pt" }}
                              >
                                {size.name}
                              </Text>
                              <Text
                                style={{
                                  ...styles.textLight,
                                  fontSize: "16pt",
                                }}
                              >
                                {size.unit}
                              </Text>
                            </View>
                            {/* <View style={{...styles.productsize, marginTop: 2}}>
                            <Text style={{...styles.textBold, fontSize: '16pt'}}>{size.thickness}</Text>
                            <Text style={{...styles.textLight, fontSize: '16pt'}}>{size.unit}&nbsp;Thickness</Text>
                          </View> */}
                          </View>
                        );
                      }):null}
                  </View>
                  {element.sizes.length > 0 ? (
                    <View
                      style={{
                        ...styles.productsize,
                        alignSelf: "flex-end",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Text
                        style={{
                          ...styles.textBold,
                          fontSize: "14pt",
                          paddingTop: "4px",
                        }}
                      >
                        {element.sizes[0].thickness}
                      </Text>
                      <Text style={{ ...styles.textLight, fontSize: "14pt" }}>
                        {element.sizes[0].unit}&nbsp;Thickness
                      </Text>
                    </View>
                  ):null}
                  <View
                    style={{
                      ...styles.lineBox,
                      marginTop: 18,
                      marginBottom: 18,
                    }}
                  >
                    <View style={{ ...styles.line }} />
                  </View>
                  <View style={{ ...styles.detailBox, marginTop: 10 }}>
                    <Text style={{ ...styles.textBold, fontSize: "16pt" }}>
                      Random
                    </Text>
                    <Text style={{ ...styles.textLight, fontSize: "16pt" }}>
                      &nbsp;Design
                    </Text>
                  </View>
                </View>
                <View style={{ position: "absolute", bottom: 0, right: 0 }}>
                  {element.colletion_image ? (
                    <Image
                      style={styles.logo}
                      cache={false}
                      src={element.colletion_image}
                    />
                  ):null}
                </View>
              </View>
            </View>
            {element.product.face_one ? (
              <View style={{ ...styles.productBox, marginTop: 5 }}>
                <View style={{ ...styles.firstBox, marginTop: 0 }}>
                  <View>
                    <View style={styles.imageFaceBox}>
                      {element.product.face_one ? (
                        <Image
                          cache={false}
                          style={styles.faceImage}
                          src={element.product.face_one}
                        />
                      ):null}
                      {element.product.face_two ? (
                        <Image
                          cache={false}
                          style={styles.faceImage}
                          src={element.product.face_two}
                        />
                      ):null}
                      {element.product.face_three ? (
                        <Image
                          cache={false}
                          style={styles.faceImage}
                          src={element.product.face_three}
                        />
                      ):null}
                    </View>
                    {/* {element.product.face_four && (
                  <View style={styles.imageFaceBox}>
                    {element.product.face_four && (
                      <Image
                        style={styles.faceImage}
                        src={element.product.face_four}
                      />
                    )}
                    {element.product.face_five && (
                      <Image
                        style={styles.faceImage}
                        src={element.product.face_five}
                      />
                    )}
                    {element.product.face_six && (
                      <Image
                        style={styles.faceImage}
                        src={element.product.face_six}
                      />
                    )}
                  </View>
                )} */}
                  </View>
                </View>
                <View
                  style={{
                    ...styles.secondBox,
                    marginTop: 0,
                    position: "relative",
                  }}
                >
                  <View style={{ position: "absolute", bottom: 2, right: 0 }}>
                    {(element.website && !withoutlogo) ? (
                      <Text style={{ ...styles.textLight, fontSize: "12pt" }}>
                        {element.website}
                      </Text>
                    ):null}
                  </View>
                </View>
              </View>
            ):null}
          </View>
        </View>
      ):null}
      {(element.product.preview && !element.is_hide_preview) ? (
        <View style={{ position: "relative" }}>
          <Svg viewBox="0 0 595 842" width="100%" height="841.8">
            <Defs>
              <LinearGradient
                id="myLinearGradient"
                x1="1"
                y1="1.5"
                x2="0"
                y2="0"
              >
                <Stop offset="0%" stopColor={bgColorTwo} />
                <Stop offset="100%" stopColor={bgColor} />
              </LinearGradient>
            </Defs>
            <Rect
              fill="url('#myLinearGradient')"
              x="0"
              y="0"
              width="100%"
              height="842"
            />
          </Svg>
          <View
            style={{
              position: "absolute",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              padding: 50,
            }}
          >
          
            <View style={styles.previeWImageDetail}>
              <Image
                style={styles.previewImage}
                cache={false}
                src={element.product.preview}
              />
            </View>
            <View style={styles.previewDetail}>
              <View style={styles.leftBox}>
                <Image
                  src={element.image}
                  cache={false}
                  style={{ height: 366, width: 183 }}
                />
              </View>

              {element.sizes.length === 2 ? (
                <View style={styles.rightBox}>
                  <View>
                    {element.product.face_one ? (
                      <View style={styles.imageBottomFaceBox}>
                        {element.product.face_one ? (
                          <Image
                            cache={false}
                            style={styles.imageface}
                            src={element.product.face_one}
                          />
                        ):null}
                        {element.product.face_two ? (
                          <Image
                            cache={false}
                            style={styles.imageface}
                            src={element.product.face_two}
                          />
                        ):null}
                        {element.product.face_three ? (
                          <Image
                            cache={false}
                            style={styles.imageface}
                            src={element.product.face_three}
                          />
                        ):null}
                      </View>
                    ) : (
                      <View style={{ height: 140, display: "flex" }}></View>
                    )}
                    <View
                      style={{
                        marginTop: 10,
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Text
                        style={{
                          ...styles.previewTextBold,
                          fontFamily: "NexaBold",
                          fontSize: "12pt",
                        }}
                      >
                        Random
                      </Text>
                      <Text
                        style={{
                          ...styles.previewTextBold,
                          fontFamily: "NexaLight",
                          fontSize: "12pt",
                        }}
                      >
                        &nbsp;Design
                      </Text>
                    </View>
                  </View>
                  <View>
                    <Text
                      style={{
                        ...styles.previewproductName,
                        fontSize: "20pt",
                        maxWidth: "70%",
                      }}
                    >
                      {element.product.name}
                    </Text>
                  </View>
                  <View>
                    <View style={styles.line}></View>
                  </View>
                  <View>
                    <Text
                      style={{
                        ...styles.previewTextLight,
                        fontSize: "10pt",
                        alignSelf: "flex-end",
                        display: "flex",
                      }}
                    >
                      Surface
                    </Text>
                    <Text
                      style={{
                        ...styles.previewTextBold,
                        marginTop: 2,
                        fontSize: "17pt",
                      }}
                    >
                      {element.series || "Glosy"}
                    </Text>
                  </View>
                  <View>
                    <View style={styles.line}></View>
                  </View>
                  <View
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    {/* <View style={{borderRight: '1px solid #000', width: "2px", height: "32pt", margin: '0px 5px 0px 5px'}}>
                  <Text style={{color: fontColor, fontSize: '34pt', margin: '0px 5px 0px 5px', fontFamily: 'NexaLight'}}>|</Text>
                </View> */}
                    <View
                      style={{
                        ...styles.sizeBox,
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      {element.sizes.length > 0 ?
                        element.sizes.map((size, key) => {
                          return (
                            <View style={{ marginTop: 10 }} key={key}>
                              <View style={styles.productsize}>
                                <Text
                                  style={{
                                    ...styles.textBold,
                                    fontSize: "14pt",
                                  }}
                                >
                                  {size.name}
                                </Text>
                                <Text
                                  style={{
                                    ...styles.textLight,
                                    fontSize: "14pt",
                                  }}
                                >
                                  {size.unit}
                                </Text>
                                {key < element.sizes.length - 1 ? (
                                  <View
                                    style={{
                                      backgroundColor: fontColor,
                                      width: "1px",
                                      height: "16pt",
                                      margin: "0px 5px 0px 5px",
                                    }}
                                  ></View>
                                ):null}
                              </View>
                              {/* <Text style={{color: fontColor, fontSize: '20pt', margin: '0px 5px 0px 5px', fontFamily: 'NexaLight'}}>|</Text> */}

                              {/* <View style={{...styles.productsize, marginTop: 2}}>
                            <Text style={{...styles.textBold,fontSize:"14pt"}}>{size.thickness}</Text>
                            <Text style={{...styles.textLight,fontSize:"14pt"}}>{size.unit}&nbsp;Thickness</Text>
                          </View> */}
                            </View>
                          );
                        }):null}
                    </View>
                    {element.sizes.length > 0 ? (
                      <View
                        style={{
                          ...styles.productsize,
                          alignSelf: "flex-end",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Text
                          style={{
                            ...styles.textBold,
                            fontSize: "14pt",
                            paddingTop: "3px",
                          }}
                        >
                          {element.sizes[0].thickness}
                        </Text>
                        <Text style={{ ...styles.textLight, fontSize: "14pt" }}>
                          {element.sizes[0].unit}&nbsp;Thickness
                        </Text>
                      </View>
                    ):null}
                  </View>
                  <View>
                    {!withoutlogo ? (
                      <Image
                        style={{ maxWidth: 150, maxHeight: 50 }}
                        cache={false}
                        src={
                          userLogo == "LOGO"
                            ? element.user_logo
                            : element.user_dark_logo
                        }
                      />
                    ):null}
                  </View>
                </View>
              ) : (
                <View style={styles.rightBox}>
                  <View>
                    {element.product.face_one ? (
                      <View style={styles.imageBottomFaceBox}>
                        {element.product.face_one ? (
                          <Image
                            style={styles.imageface}
                            src={element.product.face_one}
                          />
                        ):null}
                        {element.product.face_two ? (
                          <Image
                            cache={false}
                            style={styles.imageface}
                            src={element.product.face_two}
                          />
                        ):null}
                        {element.product.face_three ? (
                          <Image
                            cache={false}
                            style={styles.imageface}
                            src={element.product.face_three}
                          />
                        ):null}
                      </View>
                    ) : (
                      <View style={{ height: 140, display: "flex" }}></View>
                    )}
                    <View
                      style={{
                        marginTop: 10,
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Text
                        style={{
                          ...styles.previewTextBold,
                          fontFamily: "NexaBold",
                          fontSize: "12pt",
                        }}
                      >
                        Random
                      </Text>
                      <Text
                        style={{
                          ...styles.previewTextBold,
                          fontFamily: "NexaLight",
                          fontSize: "12pt",
                        }}
                      >
                        &nbsp;Design
                      </Text>
                    </View>
                  </View>
                  <View>
                    <Text
                      style={{
                        ...styles.previewproductName,
                        fontSize: "20pt",
                        maxWidth: "70%",
                      }}
                    >
                      {element.product.name}
                    </Text>
                  </View>
                  <View>
                    <View style={styles.line}></View>
                  </View>
                  <View
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <View>
                      <Text
                        style={{ ...styles.previewTextLight, fontSize: "12pt" }}
                      >
                        Surface
                      </Text>
                      <Text
                        style={{
                          ...styles.previewTextBold,
                          marginTop: 2,
                          fontSize: "19pt",
                        }}
                      >
                        {element.series || "Glosy"}
                      </Text>
                    </View>

                    <View
                      style={{
                        borderRight: "1px solid",
                        backgroundColor: fontColor,
                        width: "2px",
                        height: "32pt",
                        margin: "0px 5px 0px 5px",
                      }}
                    >
                      {/* <Text style={{color: fontColor, fontSize: '34pt', margin: '0px 5px 0px 5px', fontFamily: 'NexaLight'}}>|</Text> */}
                    </View>
                    <View style={styles.sizeBox}>
                      {element.sizes.length > 0 ?
                        element.sizes.map((size, key) => {
                          return (
                            <View style={{ marginTop: 10 }} key={key}>
                              <View style={styles.productsize}>
                                <Text
                                  style={{
                                    ...styles.textBold,
                                    fontSize: "16pt",
                                  }}
                                >
                                  {size.name}
                                </Text>
                                <Text
                                  style={{
                                    ...styles.textLight,
                                    fontSize: "16pt",
                                  }}
                                >
                                  {size.unit}
                                </Text>
                              </View>
                              <View
                                style={{ ...styles.productsize, marginTop: 2 }}
                              >
                                <Text
                                  style={{
                                    ...styles.textBold,
                                    fontSize: "16pt",
                                    paddingTop: "4px",
                                  }}
                                >
                                  {size.thickness}
                                </Text>
                                <Text
                                  style={{
                                    ...styles.textLight,
                                    fontSize: "16pt",
                                  }}
                                >
                                  {size.unit}&nbsp;Thickness
                                </Text>
                              </View>
                            </View>
                          );
                        }):null}
                    </View>
                  </View>

                  {/* <View style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                <View>
                  <Text style={{...styles.previewTextLight,fontSize: '12pt'}}>Surface</Text>
                  <Text style={{...styles.previewTextBold, marginTop: 2, fontSize: "19pt"}}>
                    {element.series || 'Glosy'}
                  </Text>
                </View>

                <View style={{borderRight: '1px solid #000', width: "2px", height: "32pt", margin: '0px 5px 0px 5px'}}>
                  <Text style={{color: fontColor, fontSize: '34pt', margin: '0px 5px 0px 5px', fontFamily: 'NexaLight'}}>|</Text>
                </View>
                <View style={styles.sizeBox}>
                  {element.sizes.length > 0 &&
                    element.sizes.map((size, key) => {
                      return (
                        <View
                          style={{ marginTop: 10 }}
                          key={key}
                        >
                          <View style={styles.productsize}>
                            <Text style={{...styles.textBold,fontSize:"16pt"}}>{size.name}</Text>
                            <Text style={{...styles.textLight,fontSize:"16pt"}}>{size.unit}</Text>
                          </View>
                          <View style={{...styles.productsize, marginTop: 2}}>
                            <Text style={{...styles.textBold,fontSize:"16pt"}}>{size.thickness}</Text>
                            <Text style={{...styles.textLight,fontSize:"16pt"}}>{size.unit}&nbsp;Thickness</Text>
                          </View>
                        </View>
                      );
                    })}
                </View>
              </View> */}
                  <View>
                    {!withoutlogo ? (
                      <Image
                        style={{ maxWidth: 150, maxHeight: 50 }}
                        cache={false}
                        src={
                          userLogo == "LOGO"
                            ? element.user_logo
                            : element.user_dark_logo
                        }
                      />
                    ):null}
                  </View>
                </View>
              )}
            </View>
          </View>
        </View>
      ):null}
    
    </View>
  );
};
export default VerticalProduct;
